<template>
	<div class="layout">
		<div class="head">
			<div class="head-left">
				<div class="head-left-logo">
					<img src="../../public/TitleLogo.jpg" />
					<label>不二账</label>
				</div>
			</div>
			<div class="head-center">
			</div>
			<div class="head-right">
				<button class="jxyd-button" style="display: inline-block;margin-right: 20px;" @click="register">注册</button>
				<button class="jxyd-button jxyd-primary" style="display: inline-block;" @click="login">登录</button>
			</div>
		</div>
		<div class="layout-body">
			<div class="layout-body-part1">
				<div class="layout-body-part1-left">
					<div class="layout-body-part1-text">
						移动端、电脑端一键统管「不二账」
					</div>
					<div class="layout-body-part1-text" style="color: #ff6a7f;">
						您的全能型进销存智控中枢，赋能生意，<br/>跨越零售与电商界限！
					</div>
				</div>
				<div class="layout-body-part1-right">
					<img src="../assets/imgs/phone001.jpg" width="250" height="250"/>
					<img src="../assets/imgs/computer001.jpg" width="250" height="250"/>
				</div>
			</div>
			<div class="layout-body-part2">
				<div class="layout-body-part2-right">
					<div class="layout-body-part2-text">
						强大且完备的经营数据分析，助力商户掌握详尽的经营信息！
					</div>
					<div class="layout-body-part2-text">
						拥有更丰富的产品线，提供进货、销售、库存、收付款的一站式解决方案。
					</div>
					<div class="layout-body-part2-text">
						友好的操作体验！方便快捷，缩减复杂操作，让操作简单有效！
					</div>
					<div class="layout-body-part2-text">
						完善且有效的权限分级！轻松分配员工权限，保护敏感数据！
					</div>
				</div>
			</div>
			<div class="layout-body-part3">
				<div class="layout-body-part3-left">
					<div class="layout-body-part3-left-part">
						<div class="layout-body-part3-left-part-title">
							全功能开放，不收取费用
						</div>
						<div class="layout-body-part3-left-part-content">
							为建立良好生态，现阶段全功能免费开放，为各大商户、企业推动店铺经营数字化！
						</div>
					</div>
					<div class="layout-body-part3-left-part">
						<div class="layout-body-part3-left-part-title">
							版本升级迭代
						</div>
						<div class="layout-body-part3-left-part-content">
							产品每月至少更新一个版本，每次至少新增优化3个功能，产品团队切实听取用户声音，了解最新业务需要，确保软件好用顺手！
						</div>
					</div>
				</div>
				<div class="layout-body-part3-right">
					<div class="layout-body-part3-right-part">
						<h1>高级别加密数据储存</h1>
						<div class="layout-body-part3-right-part-content">对数据进行高级别加密,储存在腾讯云多服务器，多层防火墙阻断恶意攻击和侵入</div>
					</div>
				</div>
			</div>
		</div>
		<div class="page-foot">
			— <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2024093359号-6</a>｜京公网安备11011202101626号 —
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	export default {
		name: 'productintroduction',
		data() {
			return {
				redirect:''
			}
		},
		methods: {
			register(){
				this.$router.push({
					path: 'login',
					query: {
						type: 'register',
						redirect :this.redirect
					}
				});
			},
			login(){
				this.$router.push({
					path: 'login',
					query: {
						type: 'login',
						redirect :this.redirect
					}
				});
			}
		},
		watch: {
			$route: {
				handler(route) {
					this.redirect = route.query && route.query.redirect
				},
				immediate: true,
			},
		},
		created: function() {},
		mounted() {}
	}
</script>

<style scoped>
	body{
		word-break: break-all;
	}
	.layout {
		background-color: white;
		overflow-x: auto;
		height: 100%;
		width: 100%;
		min-width: 1600px;
		min-height: 700px;
	}

	.head {
		width: 100%;
		margin: 0px auto;
		overflow: hidden;
		background-color: white;
		padding: 10px;
		position: absolute;
		top: 0;
		left: 0;
		min-width: 1600px;
	}

	.head-left {
		float: left;
		width: 15%;
	}

	.head-left-logo {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.head-left-logo img {
		width: 30px;
		height: 30px;
	}

	.head-left-logo label {
		font-size: 16px;
		font-weight: bold;
	}
	
	.head-center{
		width: 55%;
	}

	.head-right {
		float: right;
		width: 30%;
		text-align: center;
	}
	
	.layout-body{
		overflow-y: auto;
		background-color: white;
		margin-top: 10px;
	}
	
	.layout-body-part1{
		margin: 100px auto;
		overflow: hidden;
		width: 80%;
	}
	
	.layout-body-part1-text{
		color: #333;
		text-align: left;
		font-size: 35px;
	}
	
	.layout-body-part1-left{
		float: left;
		width: 55%;
	}
	
	.layout-body-part1-right{
		float: right;
		width: 45%;
	}
	
	.layout-body-part2{
		background-image: url('../assets/imgs/computer002.jpg');
		background-size:100% 100%;
		/* 背景图片填充整个伪元素区域，保持其宽高比 */
		background-position:center;
		/* 图片居中显示（可以根据需求调整） */
		left: 0;
		/* 将伪元素定位到容器左侧 */
		top: 0;
		/* 定位到容器顶部 */
		height: 500px;
		overflow: hidden;
	}
	.layout-body-part2-right{
		float: right;
		margin-top: 50px;
	}
	.layout-body-part2-text{
		border-left: 3px solid #ff6a7f;
		padding: 15px;
		border-radius: 10px;
		background-color: white;
		color: #ff6a7f;
		margin-top: 20px;
		margin-right: 200px;
		font-weight: bold;
	}
	
	.layout-body-part3{
		overflow: hidden;
		padding-top: 50px;
		padding-bottom: 50px;
		width: 80%;
		margin: 0px auto;
	}
	
	.layout-body-part3-left{
		float: left;
		width: 60%;
	}
	.layout-body-part3-left-part{
		padding: 40px;
		box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
		border-radius:30px;
		margin-bottom: 20px;
		margin-left: 10px;
	}
	.layout-body-part3-right{
		float: left;
		width: 40%;
		padding-left: 30px;
		padding-right: 10px;
	}
	.layout-body-part3-left-part-title{
		font-weight: bold;
		font-size: 18px;
	}
	
	.layout-body-part3-left-part-content{
		
	}
	
	.layout-body-part3-right-part{
		border-radius:30px;
		height: 300px;
		background-color: #ff6a7f;
		padding: 40px;
		color: #fff;
	}
	
	.layout-body-part3-right-part-content{
		font-size: 16px;
	}
	
	.page-foot {
		width: 100%;
		text-align: center;
		position: absolute;
		bottom: 10px;
		left: 0;
		/* 或者 right: 0; 根据需要将元素定位到左边或右边 */
		color:grey;
	}
</style>